/**
 * The backend's cap on one Velo chat message: `AiChatRequest.message` carries
 * `@Size(max = 8000)` and answers a longer one with a 400 `messageTooLong`
 * before the stream starts. Java counts UTF-16 code units, exactly like
 * `String.prototype.length`, so the composer can check the same number before
 * sending instead of losing the draft to a refusal.
 */
export const MAX_AI_MESSAGE_CHARS = 8000;

/** From here on the composer shows the running count next to the limit. */
export const AI_MESSAGE_COUNT_FROM = Math.floor(MAX_AI_MESSAGE_CHARS * 0.9);

/**
 * Error codes a retry cannot fix: the retry chip resends the SAME text, so a
 * too-long message would fail the same way every time.
 */
export function isRetryableAiError(code: string | undefined): boolean {
  return !!code && code !== "messageTooLong";
}
